const basePath = 'https://files.keithmcmillen.com/products/mallet-station/'

export default {
  base: basePath,
  factoryPresets: basePath + "editor/factoryPresetsV1.1.json", // current
  factoryPresetsBeta: basePath + "editor/factoryPresetsBeta.json",
  factoryPresetsVersion: basePath + "editor/factoryPresetsVersion.json",
  factoryPresetsVersionBeta: basePath + "editor/factoryPresetsVersionBeta.json",
  // editor version, firmare version, firmware path
  firmwareCurrentVersion: basePath + "firmware/currentVersionV1.1.json", // current
  firmwareCurrentVersionBeta: basePath + "firmware/currentVersionBeta.json",
  firmwareCurrentVersionBetas: basePath + "firmware/currentVersionBetas.json",
  editorCurrentVersion: basePath + "editor/currentVersionV1.1.json", // current
  editorCurrentVersionBeta: basePath + "editor/currentVersionBeta.json",
  editorCurrentVersionBetas: basePath + "editor/currentVersionBetas.json",
};
